import { testMatch, sleep, fullDecode } from '../libs/utils';
import store from '../store';
import { formatUserInput, logX } from '../common/libs/utils';
import { post } from './http';
import { saveVariable } from './userVariables';
import whevent from 'whevent';
import { save, load, parseJSON } from '../common/libs/utils';
import { processText, getAllVariables } from './userVariables';
import { sendMessage } from '../common/libs/iframer';

let action, overrideUkey;

const validate_logical_query = function (u, q) {
	const unserialize = function (paramStr, rowSpliter, kvSpliter) {
		if (!paramStr) return null;
		rowSpliter = rowSpliter || "&";
		kvSpliter = kvSpliter || "=";
		paramStr = paramStr.replace(/^(.*)\?/i, '');
		var parts = paramStr.split(rowSpliter);
		var params = {};
		for (var i = 0, p; p = parts[i]; i++) {
			var ps = p.split(kvSpliter);
			if (ps.length == 2)
				params[ps[0].trim()] = ps[1];
		}
		return params;
	}

	const filters = {
		"eq": function (d, k, v) { return d[k] == v; },
		"ne": function (d, k, v) { return d[k] != v; },
		"lt": function (d, k, v) { return d[k] < v; },
		"gt": function (d, k, v) { return d[k] > v; },
		"le": function (d, k, v) { return d[k] <= v; },
		"ge": function (d, k, v) { return d[k] >= v; },
		"l": function (d, k, v) { return d[k] && v && `${d[k]}`.includes(v) },
		"nl": function (d, k, v) { return !(d[k] && v && `${d[k]}`.includes(v)) },
		"in": function (d, k, v) { if (!v) return false; for (var i in v) { if (v[i] == d[k]) return true; } return false; },
		"nin": function (d, k, v) { if (!v) return true; for (var i in v) { if (v[i] == d[k]) return false; } return true; },
		"bt": function (d, k, v) { return d[k] >= Math.min(v[0], v[1]) && d[k] <= Math.max(v[0], v[1]); },
		"nb": function (d, k, v) { return d[k] < Math.min(v[0], v[1]) || d[k] > Math.max(v[0], v[1]); },
		"m": function (d, k, v) { if (v.charAt(0) != "%") v = "^" + v; if (v.charAt(v.length - 1) != "%") v = v + "$"; return d[k] != null && new RegExp(v.replace(/%/g, "(.*)"), "ig").test(d[k]); },
		"nm": function (d, k, v) { if (v.charAt(0) != "%") v = "^" + v; if (v.charAt(v.length - 1) != "%") v = v + "$"; return d[k] == null || !(new RegExp(v.replace(/%/g, "(.*)"), "ig").test(d[k])); },
	};

	let cs = unserialize(q);
	for (let [k, v] of Object.entries(cs)) {
		k = k.replace(/[{}]/g, '').replace(/^user\./, '');
		let [uk, cmd] = k.split('@');
		cmd = cmd || 'eq';
		if (cmd == 'eq' && v == 'NULL' && u[uk]) return false;
		let f = filters[cmd];
		if (!f || !f(u, uk, v)) return false;
	}
	return true;
}

const get_myfids = function (bot, u) {
	const empty = d => [null, undefined, ''].includes(d);
	const get_ukeys_by_botvars = function (botvars) {
		let cfields = [];
		for (let bv of botvars) {
			if (bv['isc'] || bv['value'].startsWith("user.c_")) {
				let k = bv['value'].replace("user.", "");
				if (bv['isukey']) {// ukey of reaction
					cfields.push(k);
				} else {           // c_xxx
					for (let t of bv['types']) {
						cfields.push(`${k}_${t}`);
					}
				}
			}
		}
		// unique: Instead of "$.unique" for browsers and nodejs
		cfields = cfields.filter((v, i, self) => { return self.indexOf(v) === i; });
		return cfields;
	}

	let myfids = [], f_tags, orgk, is_t, v1, v2, u_tags, i_tags, is_ok, vs, u_vs;


	let time = new Date().getTime() / 1000;
	let bid = bot['id'];
	let uid = u['id'];
	let fgs = bot['filter_groups'];
	if (empty(fgs)) return myfids;

	let cfields = get_ukeys_by_botvars(bot["botvars"]);
	for (let f of fgs) {
		let ac = [];
		let data = !empty(f.data) ? (typeof f.data === 'string' ? JSON.parse(f['data']) : f.data) : false;
		if (data === false) continue;
		let d_keys = Object.keys(data);
		if (empty(d_keys)) {//  
			//myfids.push(f['id']);
			continue;
		}

		let in_cnt = 0;
		let is_not_in = false;
		for (let k of Object.keys(data)) {
			if (empty(k)) continue;
			let o = data[k];
			if (empty(o) && o !== '0') continue;
			let u_v = u[k];
			// tag
			if ((k == 'tags' || k == "ref" || k.match(/^ref_[^\0]*/im) && !['ref_uid', 'ref_c'].includes(k)) && typeof o !== 'object') {
				f_tags = typeof o === 'string' ? o.split("\n") : (o ? o : []);
				f_tags = f_tags.map(tag => escape(tag));
				u_tags = typeof u_v === 'string' ? u_v.split("\n") : (u_v ? u_v : []);
				i_tags = f_tags && f_tags.filter ? f_tags.filter(v => u_tags.indexOf(v) > -1) : [];// array_intersect
				if (i_tags.length <= 0) {
					is_not_in = true; break;
				}
				in_cnt++;
				continue;
			}

			// swipe like/dislike
			if (k == "swipe_items") {
				//sample : $o = "cl:1,cl:2,ec:1";//catalogs_$bid.id=1, id=2, ec_items:bid=thisBid,id=1
				let ss = o.split(",");
				let ecs = []; let cls = []; let sts = [];
				ss.forEach(function (k) {
					let [s, id] = k.split(":");
					if (s == "ec") ecs.push(id);
					if (s == "cl") cls.push(id);
					if (s == "st") sts.push(id);
				})
				let hit_ec = u.swipe_items ? ecs.filter(function (id) { return u.swipe_items.ec_items.indexOf(id) >= 0 }) : [];
				let hit_cl = u.swipe_items ? cls.filter(function (id) { return u.swipe_items.catalogs.indexOf(id) >= 0 }) : [];
				let hit_st = u.swipe_items ? sts.filter(function (id) { return u.swipe_items.stores.indexOf(id) >= 0 }) : [];
				if (hit_ec.length == 0 && hit_cl.length == 0 && hit_st.length == 0) {
					is_not_in = true; break;
				}
				in_cnt++;
				continue;
			}
			k = k.replace(/^user./g, "")
			// Basical attributes
			if (k.match(/_[12]$/) || k.match(/_t_(from|to)$/)) {
				orgk = k.replace(/_t_(from|to)$/g, "_t");
				orgk = orgk.replace(/_[12]$/g, "");
				if (ac[orgk]) {
					delete (ac[k]); continue;
				}
				v1 = data[orgk + "_1"];
				v2 = data[orgk + "_2"];
				is_t = orgk.match(/_t$/);
				u_v = u[orgk];
				if (!u_v || u_v == null) {// fixed: check is null
					is_not_in = true; break;
				}
				v1 = is_t && v1 ? time - parseInt(v1) * 86400 : parseInt(v1 || 0);
				v2 = is_t && v2 ? time - parseInt(v2) * 86400 : parseInt(v2 || 0);

				if (is_t) {
					var vf = data[orgk + "_from"];
					var vt = data[orgk + "_to"];

					if (v1 != 0) {
						if (vf) {
							v1 = Math.max(v1, vf);
						}
					} else {
						v1 = vf || 0;
					}

					if (v2 != 0) {
						if (vt) {
							v2 = Math.min(v2, vt);
						}
					} else {
						v2 = vt || 0;
					}
				}

				if (v1 != 0 && v2 != 0) {

					ac[orgk] = true;
					if (u_v >= v1 && u_v <= v2) {
						in_cnt++;
					} else {
						is_not_in = true; break;
					}
				} else if (v1 != 0) {
					ac[orgk] = true;
					if (u_v >= v1) {
						in_cnt++;
					} else {
						is_not_in = true; break;
					}
				} else if (v2 != 0) {
					ac[orgk] = true;
					if (u_v <= v2) {
						in_cnt++;
					} else {
						is_not_in = true; break;
					}
				}
				continue;
			}

			// 招待成功数
			if (k == 'ref_c' && o > 0) {
				if (u['ref_c'] >= o) {
					in_cnt++;
				} else {
					is_not_in = true; break;
				}
			}
			// 被招待者
			if (k == 'ref_uid' && o > 0) {
				if (u['ref_uid'] > 0) {
					in_cnt++;
				} else {
					is_not_in = true; break;
				}
			}

			// Additional attributes
			// bugfxied: 指定したセグメントグループ毎にリッチメニューが切り替わらない #408
			// $cfieldsの制限を解除します。そうしないと、ミニアプリのUkeyを実行できません。
			//if(cfields.indexOf(k)>=0) {
			if (typeof o === 'object') {
				is_ok = false;
				if (o['comp'] == 'empty' && empty(u_v)) {
					is_ok = true;
				} else if (o['comp'] == '!empty' && !empty(u_v)) {
					is_ok = true;
				} else if (o['comp'] == 'in' && !empty(u_v)) {
					vs = o['v'].split("\n");
					u_vs = (typeof u_v === 'string' ? u_v : `${u_v}`).split("\n");
					for (let v of u_vs) {
						if (vs.indexOf(v) >= 0) {
							is_ok = true; break;
						}
					}
				} else if (o['comp'] == 'eq' && u_v == o['v']) {
					is_ok = true;
				} else if (o['comp'] == 'bt' && !empty(u_v)) {
					let [start, end] = o['v'].split(",");
					start = parseFloat(start);
					end = parseFloat(end);
					if (!end) {
						end = start;
						start = 0;
					}
					if (u_v >= start && u_v <= end) {
						is_ok = true;
					}
				} else if (o['comp'] == 'm') {
					// Not needed now
				} else if (o['comp'] == 'nm') {
					// Not needed now
				}
				if (is_ok) {
					in_cnt++;
				} else {
					is_not_in = true; break;
				}
			}
			continue;
			//}

			if (typeof o !== 'object') { // Ignore key, exapmle: 'name'
				// ignore
			} else {
				// basic info like name, email ...
				if (o['comp'] == '!empty' && !empty(u_v)) {
					in_cnt++; continue;
				}
				// Unavailable key
				is_not_in = true;
			}
		}
		// insert to myfids
		let is_myfid = in_cnt > 0 && is_not_in == false;
		if (is_myfid) myfids.push(f['id']);
	}
	myfids = myfids.map(id => `${id}`);
	return myfids;
}

const getChatByActId = act => {
	const { $bot_data: bot } = window;
	const { groups } = bot;
	const [gid, aid] = act.split('-');
	const group = groups.find(g => g.id == gid) || groups[0];
	if (!group) return;
	store.state.currentGroup = group;

	const { actions } = group;
	if (!actions || !actions.length) return;
	return actions.find(a => a.id == aid) || actions[0];
};

export const getChat = async ({ data, wait, source = 'action', text, type }) => {
	if (store.state.readonly) {
		return;
	}

	const { $bot_data: bot } = window;
	if (!bot) return;
	const { groups } = bot;
	if (!groups || !groups.length) return;
	let act, newAdd = wait;

	if (type === 'app') {
		action = data;
		whevent.emit('MINIAPP', data);
	} else {
		if (source === 'initial') {
			if (store.state.start) {
				act = store.state.start;
			} else {
				act = bot.up_aid;
			}
			newAdd = true;
		} else if (['action', 'miniapp'].includes(source)) {
			if(data.type === 'url' && data.uri) {
				const uri = fullDecode(data.uri);
				if(data.uri_via == 'direct') {
					window.location.href = uri;
				} else {
					window.open(uri);
				}
				return;
			}
			act = data.act || data.next;
			if (!act) {
				if (data.trans_type !== 'next') return;
				const index = store.state.currentGroup.actions.findIndex(e => e.id == data.aid);
				if (index < 0 || index >= store.state.currentGroup.actions.length - 1) return;
				console.log(index, store.state.currentGroup.actions);
				act = store.state.currentGroup.id + '-' + store.state.currentGroup.actions[index + 1].id;
				if (!act) return;
			} else if (act == 0) {
				return;
			}
			newAdd = true;
		} else if (source === 'input') {
			let _action = data || store.state.currentAction;

			if (_action && _action.ipts) {
				const globalError = store.state.bot.qas?.find(e => e.match_type === 'global_error');
				const target = _action.ipts.filter(e => e.match_type !== 'global_error').find(e => testMatch(e, text));
				// TODO: verify input
				if (target) {
					act = target.act;
					if (target.ukey) {
						data.ukey = target.ukey;
						overrideUkey = target.ukey;
						saveVariable(target.ukey, target.uval || text, target, source);
					}
				} else {
					action = globalError;
				}
				newAdd = true;
			} else if (store.state.bot.qas) {
				const globalError = store.state.bot.qas.find(e => e.match_type === 'global_error');
				const target = store.state.bot.qas.filter(e => e.match_type !== 'global_error').find(e => testMatch(e, text));
				if (target) {
					if (target.act) {
						data = target;
						act = data.act;
					} else if (target.msg) {
						action = target;
					}
				} else {
					action = globalError;
				}
			} else {
				return;
			}
		} else {
			return;
		}

		if (!action) {
			action = getChatByActId(act);
		}

		if (!action) {
			return;
		}
	}

	if (action !== store.state.bot.qas?.find(e => e.match_type === 'global_error')) {
		store.state.currentAction = action;
	}

	if (action.meta) {
		if (typeof action.meta === 'string') {
			try {
				action.meta = JSON.parse(action.meta);
			} catch (ex) {
				console.error('unknown meta', action.meta);
			}
		}
		if (Array.isArray(action.meta)) {
			for (let meta of action.meta) {
				if (meta.else) {
					action = getChatByActId(meta.else);
					break;
				} else {
					if (meta.if === 'time') {
						if (new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' }) > meta.time) {
							action = getChatByActId(meta.then);
							break;
						}
					} else if (meta.if === 'ukey') {
						if (validate_logical_query({ ...store.state.user }, meta.condition)) {
							action = getChatByActId(meta.then);
							break;
						}
					} else if (meta.if) {
						const fids = get_myfids(store.state.bot, { ...store.state.user });
						if (fids && fids.includes(meta.if)) {
							action = getChatByActId(meta.then);
							break;
						}
					}
				}
			}
		}
	}

	if (action.next) {
		setTimeout(action => {
			getChat({ data: action });
		}, 2000 + (action.next_span || 0) * ({ day: 24 * 60 * 60 * 1000, hour: 60 * 60 * 1000, minute: 60 * 1000, second: 1000 }[action.next_unit] || 1000), action);
	}

	const chat = {
		...action,
		ins_t: new Date().getTime() * 0.001,
		action: true,
		newAdd: newAdd
	};
	pushSectionChat(chat);
	action = null;

	if (newAdd && !store.state.noWait) {
		await sleep(1000);
	}

	store.state.chats = [...store.state.chats, chat];

	save('chat-history', JSON.stringify(store.state.chats));
};

export const sendChat = async ({ text, data, type, from = 'user', follow = true, source, hidden, offline }) => {
	if (store.state.readonly) {
		return;
	}

	if (from === 'user') {
		text = formatUserInput(text);
		if (data?.ukey) {
			saveVariable(data.ukey, data.uval || text, data, source);
		}
	}

	const chat = {
		from,
		fid: from,
		msg: text,
		ins_t: new Date().getTime() * 0.001,
		id:
			new Date().getTime() +
			'_' +
			Math.random()
				.toString()
				.replace(/^0\./, ''),
		newAdd: true,
		data,
		type,
		hidden,
		offline
	};

	whevent.emit('SEND_CHAT', chat);

	pushSectionChat(chat);

	store.state.chats = [...store.state.chats, chat];
	if (follow) getChat({ data, wait: true, source, text, type });
};

let sectionChats = [];

const pushServerChats = async chats => {
	if (['draft', 'preview'].includes(store.state.mode)) return;
	const { access_key, token } = store.state.user;
	const payload = {
		access_key,
		token,
		msgs: chats
	};

	try {
		await post('/', payload, { 'Content-Type': 'application/json;charset=utf-8' }, { json: true });
		logX('SERVER', 'red', chats);
	} catch (ex) {

	}
};

const propogateChats = async chats => {
	const { access_key, token } = store.state.user;
	const action = {
		access_key,
		token,
		msgs: chats
	};

	sendMessage('ACTION', { action, vars: getAllVariables() });
};

// const pushServerChats = async chats => {
// 	const { access_key, token } = store.state.user;


// 	for(let chat of chats) {
// 		const payload = {
// 			access_key,
// 			token,
// 			time: new Date().getTime(),
// 			...chat
// 		};

// 		if(chat.from ==='user') {
// 			payload.answer = chat.msg;
// 		}

// 		try {
// 			await post('/', payload, { 'Content-Type': 'application/json;charset=utf-8' }, { json: true });
// 			logX('SERVER', 'red', chats);
// 		} catch (ex) {

// 		}
// 	}
// };

const pushSectionChat = async chat => {
	if (chat.from === 'user') {
		logX('USER', 'green', chat);
	} else {
		logX('BOT', 'orange', chat);
	}

	sectionChats.push(chat);

	if (chat.from !== 'user') {
		// email process
		let emailChats = sectionChats.filter(c => c.data?.ext?.email);
		emailChats.forEach(c => {
			if (c.data.ext.email.msg) {
				c.data.ext.email.msg = processText(c.data.ext.email.msg);
			}

			if (c.data.ext.email.title) {
				c.data.ext.email.title = processText(c.data.ext.email.title);
			}
		});

		// text process
		sectionChats.forEach(c => {
			if (c.msg) {
				c.msg = processText(c.msg);
			}
		});

		let redir = sectionChats.find(c => c.data && c.data.ext && c.data.ext.ad && c.data.ext.ad.redirect_url);
		if (redir) {
			window.open(redir.data.ext.ad.thanks_url);
			// window.location.href = redir.data.ext.ad.redirect_url;
		} else {
			redir = sectionChats.find(c => c.data && c.data.ext && c.data.ext.ad && c.data.ext.ad.thanks_url);
			if (redir) {
				window.open(redir.data.ext.ad.thanks_url);
				// window.location.href = redir2.data.ext.ad.thanks_url;
			}
		}
	} else {
		const { type, next_span } = chat.data;
		if (type === 'close') {
			sendMessage('CLOSE', { next_span });
		}
	}
	if (chat.from !== 'user' || !chat.data?.act) {
		const chats = sectionChats.reduce((acc, c) => {
			if (c.msg) {
				let el = document.createElement('textarea');
				el.innerHTML = c.msg;
				c.msg = el.value;
			}
			if (c.from === 'user') {
				let { aid, bid, gid, id, style, ukey, uval, type } = c.data || {};
				if(overrideUkey) {
					ukey = overrideUkey;
					overrideUkey = null; 
				}
				const data = {
					from: 'user',
					msg: c.msg,
					aid,
					bid,
					gid,
					style,
					ukey,
					// ukey: ukey || `c_${gid}_${aid}_${type || 'unknown'}`,
					uval: uval || c.msg,
					rid: id,
					data: c.data
				};

				if (c.data?.ext) {
					data.ext = c.data.ext;
				}

				if (c.data?.url) {
					data.url = c.data.url;
				}

				acc.push(data);
			} else {
				if (c.before_msgs && typeof c.before_msgs === 'string' && c.before_msgs.startsWith('[')) {
					parseJSON(c.before_msgs).forEach(e => {
						acc.push({
							from: 'bot',
							msg: e
						});
					});
				}

				const { aid, gid, upd_t, style } = c.data || c;
				const msg = c.msg || (c.data && c.data.msg) || '';

				const data = {
					from: 'bot',
					msg,
					gid,
					aid,
					style,
					time: upd_t
				};

				acc.push(data);
			}
			return acc;
		}, []);

		if (!chat.offline) {
			propogateChats(chats);
			await pushServerChats(chats);
		}

		sectionChats.length = 0;
	}
};

export const loadChats = () => {
	const history = load('chat-history');
	if (history) {
		store.state.chats = parseJSON(history);
	}
}
